import { add } from "@fluorescent/dom";

// eslint-disable-next-line valid-jsdoc
/**
 * A fade in and slide up reveal with split text lines
 * @param {Object} node the target element for the animation
 * @param {Object} options optional default overrides
 * @options {Number} duration override the default duration
 * @options {Number} stagger override the default stagger duration
 */
export class FadeUpSplitReveal {
  constructor(node, options = {}) {
    this.node = node;
    this.defaultOpts = {
      duration: window.theme.animation.duration,
      stagger: window.theme.animation.delay,
    };
    this.config = { ...this.defaultOpts, ...options };
    this.type = "FadeUpSplitReveal";

    this.gsapImport = import(flu.chunks.gsap).then(
      ({ gsap, CustomEase, SplitText }) => {
        gsap.registerPlugin(CustomEase);
        gsap.registerPlugin(SplitText);
        this.itemEase = gsap.parseEase(window.theme.animation.ease);

        this.splitItems = new SplitText(this.node, {
          type: "lines",
          linesClass: "animation-fade-up-split-reveal__line split-text-line",
          lineThreshold: 0.5,
        });
        this.lineCount = this.splitItems.lines.length;

        gsap.set(this.splitItems.lines, { y: "20px", opacity: 0 });

        add(this.node, "animation-initialized");

        return { gsap };
      }
    );
  }

  play(delay = 0) {
    this.gsapImport.then(({ gsap }) => {
      gsap.to(this.splitItems.lines, {
        y: 0,
        opacity: 1,
        duration: this.config.duration,
        delay: delay,
        stagger: this.config.stagger,
        ease: this.itemEase,
        onComplete: () => {
          this.splitItems.revert();
        },
      });
    });
  }
}
